import {Beer} from 'typescript/models/Beer';
import {PubBeer} from 'typescript/models/PubBeer';

export const isPubBeersArray = (beerArray: any[]): beerArray is PubBeer[] => beerArray[0]?.type === 'pub_beer';

export const isRegularBeersArray = (beerArray: any[]): beerArray is Beer[] => beerArray[0]?.type === 'beer';
